module.exports = (__parcel__import__("kf5pS")).then(() => parcelRequire('kR75W'));